<template>
  <div>
    <v-chip
      color="error"
      small
      @click="$emit('click')"
      @click.native.stop
    >
      <v-icon left small color="red darken-4">error</v-icon>
      <span class="font-weight-bold">Missing Abstract</span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'MissingAbstractChip',
};
</script>
